import { render, staticRenderFns } from "./showTab.vue?vue&type=template&id=065bd11b"
import script from "./showTab.vue?vue&type=script&lang=js"
export * from "./showTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports